import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDestroyTraining } from 'modules/trainings/hooks/Trainings/useDestroyTraining'

const DeleteTraining = () => {
  const { destroyTraining } = useDestroyTraining()
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const back = () => navigate(navigation.trainings.list.index.fullPath())

  const onSubmit = async () => {
    const response = await destroyTraining({ ids: [String(id)] })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.delete_training.error_delete'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.delete_training.success_delete'),
      })

      back()
    }
  }

  return (
    <Modal
      title={i18n.t('trainings.delete_training.title')}
      description={i18n.t('trainings.delete_training.description')}
      onSubmit={onSubmit}
      onClose={back}
      footer={
        <>
          <Button.Router to={navigation.trainings.list.index.fullPath()}>
            {i18n.t('trainings.delete_training.cancel')}
          </Button.Router>
          <Button submit>{i18n.t('trainings.delete_training.accept')}</Button>
        </>
      }
    ></Modal>
  )
}

export default DeleteTraining
